import * as cnMarketplaceConfig from '@/models/config/marketplace/cn';
import * as marketplaceCNConfig from '@/assets/marketplaces/cn/configs';
import * as enMarketplaceConfig from '@/models/config/marketplace/en';

const MARKETPLACECONFIG = {
  AAHKV2X7AFYLW: { ...cnMarketplaceConfig, ...marketplaceCNConfig },
  ATVPDKIKX0DER: enMarketplaceConfig
};

// Parsing the navigator.userAgent value passed in by the app
export const processUserAgent = userAgent => {
  let strUserAgent = userAgent;
  if (!strUserAgent) return {};
  const partRm = strUserAgent.match(/\(.*?\)/g) || [];
  partRm.forEach(el => {
    strUserAgent = strUserAgent.replace(el, '');
  });
  return strUserAgent
    .split(' ')
    .filter(el => el)
    .reduce((pre, cur) => {
      const [key, val] = cur.split('/');
      pre[key] = val;
      return pre;
    }, {});
};

export const encryptedMarketplaceId =
  processUserAgent(navigator.userAgent).marketPlace || 'AAHKV2X7AFYLW';

export default MARKETPLACECONFIG[encryptedMarketplaceId];
